import { toast } from "react-toastify";
export const showError = (error) => {
  if (typeof error === "object") {
    for (let key in error) {
      if (Array.isArray(error[key])) {
        for (const err of error[key]) {
          showErrorMsg(err);
        }
      } else if (typeof error[key] === "string") {
        showErrorMsg(error[key]);
      } else {
        showErrorMsg("An unknown error occurred.");
      }
    }
  } else if (typeof error === "string") {
    showErrorMsg(error);
  } else {
    showErrorMsg("An unknown error occurred.");
  }
};

export const getError = (error) => {
  let stringArray = [];
  for (let key in error) {
    for (const err of error[key]) {
      stringArray.push(err);
    }
  }
  return stringArray;
};

export const showErrors = (error) => {
  for (let key in error) {
    for (const err of error[key]) {
      toast.error(`${key}: ${err}`);
    }
  }
};

export const showSuccess = (message) => {
  toast.success(message);
};

export const showInfo = (message, options = {}) => {
  return toast.info(message, options);
};

export const showErrorMsg = (
  error_msg,
  position = toast.POSITION.TOP_RIGHT
) => {
  toast.error(error_msg, { position: position });
};

export const showWarning = (warning) => {
  toast.warning(warning);
};
export const showEmptyError = (error1) => {
  toast.error(error1);
};
